'use client'

import { useState } from 'react'

import Image from 'next/image'
import Link from 'next/link'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

const ListBot = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const { replace } = useRouter()
  const [value, setValue] = useState<string>('running')
  const handleSelect = (valueSelect: string) => {
    console.log({ valueSelect })
    const params = new URLSearchParams(searchParams)
    if (valueSelect === value) return
    params.set('status', valueSelect)
    setValue(valueSelect)
    replace(`${pathname}?${params.toString()}`)
  }
  const listBots = [
    {
      name: 'Bot Running',
      type: 'All Pairs',
      status: 'running',
    },
    {
      name: 'Bot Running',
      type: 'All Pairs',
      status: 'running',
    },
    {
      name: 'Bot Running',
      type: 'All Pairs',
      status: 'running',
    },
    {
      name: 'Bot Running',
      type: 'All Pairs',
      status: 'running',
    },
    {
      name: 'Bot Paused',
      type: 'All Pairs',
      status: 'paused',
    },
    {
      name: 'Bot Paused',
      type: 'All Pairs',
      status: 'paused',
    },
    {
      name: 'Bot Paused',
      type: 'All Pairs',
      status: 'paused',
    },
    {
      name: 'Bot Stopped',
      type: 'All Pairs',
      status: 'stopped',
    },
    {
      name: 'Bot Stopped',
      type: 'All Pairs',
      status: 'stopped',
    },
    {
      name: 'Bot Stopped',
      type: 'All Pairs',
      status: 'stopped',
    },
    {
      name: 'Bot Stopped',
      type: 'All Pairs',
      status: 'stopped',
    },
  ]
  const filterBots =
    value === 'all' ? listBots : listBots.filter((i) => i.status === (searchParams.get('status') || value))
  return (
    <div className="h-full border border-white/10 p-4">
      <div className="mx-auto w-fit">
        <Select defaultValue={'running'} value={value} onValueChange={(e) => handleSelect(e)}>
          <SelectTrigger className="w-[280px] border-white/10">
            <SelectValue placeholder="Select Bots" />
          </SelectTrigger>
          <SelectContent className="bg-tb-grayscale-800 text-tb-grayscale-100 border-white/10">
            <SelectGroup>
              <SelectItem value="all">All Bots</SelectItem>
              <SelectItem value="running">Running Bots</SelectItem>
              <SelectItem value="paused">Paused Bots</SelectItem>
              <SelectItem value="stopped">Stopped Bots</SelectItem>
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>

      <div className="custom-scrollbar -mx-4 mt-4 h-full overflow-y-auto border-t border-white/10 pb-8">
        {filterBots.map(({ name, type }, i) => (
          <Link key={i} href={`/bot-deployed/${i + 1}`}>
            <div className="hover:bg-tb-grayscale-500/10 flex items-center justify-between p-4 transition-all duration-300">
              <div className="flex items-center gap-x-1">
                <div>
                  <Image src="/images/bot-icon.png" width={60} height={60} alt="Bot" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold">{name}</h2>
                  <p className="uppercase">{type}</p>
                </div>
              </div>

              <div>
                <button className="bg-tb-grayscale-700 rounded-lg p-4">{i + 1}.00</button>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default ListBot
